import { ref, nextTick } from "vue";
function useDropdownNavigation(overlayRef, dropdownListRef) {
  const activeIndex = ref(null);
  const getFocusableItems = () => dropdownListRef.value.querySelectorAll(".fh-dropdown-focusable");
  const getSelectedIndex = () => {
    const items = getFocusableItems();
    return Array.from(items).findIndex(
      (item) => item.getAttribute("aria-selected") === "true"
    );
  };
  const resetActiveIndex = () => {
    activeIndex.value = null;
  };
  const scrollToItem = (index = null) => {
    const targetIndex = index !== null ? index : getSelectedIndex();
    const item = getFocusableItems()[targetIndex];
    if (item) {
      const container = dropdownListRef.value;
      const itemOffsetTop = item.offsetTop;
      const itemHeight = item.offsetHeight;
      const containerHeight = container.clientHeight;
      const scrollPosition = itemOffsetTop - containerHeight / 2 + itemHeight / 2;
      container.scrollTop = scrollPosition;
    }
  };
  const highlightItem = (index = null) => {
    const items = getFocusableItems();
    if (index !== null && index >= 0 && index < items.length) {
      activeIndex.value = index;
      scrollToItem(index);
    } else {
      resetActiveIndex();
    }
  };
  const handleArrowNavigation = (direction) => {
    const itemsLength = getFocusableItems().length;
    let nextIndex;
    const currentIndex = activeIndex.value !== null ? activeIndex.value : getSelectedIndex();
    if (direction === "down") {
      nextIndex = currentIndex < itemsLength - 1 ? currentIndex + 1 : 0;
    } else {
      nextIndex = currentIndex > 0 ? currentIndex - 1 : itemsLength - 1;
    }
    highlightItem(nextIndex);
  };
  const handleInvokerKeydown = (event) => {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        if (!overlayRef.value.isOpen) {
          overlayRef.value.open();
        }
        nextTick(() => handleArrowNavigation("down"));
        break;
      case "ArrowUp":
        event.preventDefault();
        if (!overlayRef.value.isOpen) {
          overlayRef.value.open();
        }
        nextTick(() => handleArrowNavigation("up"));
        break;
      case "Tab":
        overlayRef.value.close();
        break;
      case "Enter":
        if (overlayRef.value.isOpen && activeIndex.value >= 0) {
          event.preventDefault();
          const highlightedItem = getFocusableItems()[activeIndex.value];
          highlightedItem == null ? void 0 : highlightedItem.click();
        } else {
          overlayRef.value.close();
        }
        break;
      default:
        if (overlayRef.value.isOpen) {
          highlightItem(-1);
        }
        break;
    }
  };
  return {
    activeIndex,
    resetActiveIndex,
    handleInvokerKeydown,
    highlightItem,
    scrollToItem
  };
}
export {
  useDropdownNavigation as default
};
//# sourceMappingURL=useDropdownNavigation.mjs.map
